import type { InferOutput } from "valibot";

declare global { const account: Account | null; }

export const accountSchema = v.nullable(v.object({
  email: v.pipe(v.string(), v.email()),
  first_name: v.string(),
  last_name: v.string(),
  display_name: v.string(),
  birthday: v.pipe(
    v.unknown(),
    v.transform((value: unknown) => value === undefined ? null : value),
    v.nullable(v.pipe(v.union([v.string(), v.date()]), v.transform(coerceDate))),
  ),
  menu_items: v.array(navMenuItemSchema),
}));
export type Account = InferOutput<typeof accountSchema>;

// 'update_account' input
export const updateAccountSchema = v.omit(v.unwrap(accountSchema), ["email", "menu_items"]);
export type UpdateAccount = InferOutput<typeof updateAccountSchema>;
